
      // Dynamic config loading
      try {
        const script = document.createElement("script");
        script.src = "config.js";
        document.head.appendChild(script);
      } catch (e) {
        console.warn("Config not found, using sample data");
      }
    